
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internal/onboarding-screen",
      function () {
        return require("private-next-pages/internal/onboarding-screen/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internal/onboarding-screen"])
      });
    }
  